import { IWidget } from '../../widgets';

export function sortWidgets(widgets: IWidget[]): IWidget[] {
    return widgets.sort((a, b) => {
        let res: number;
        if (a.row === b.row) {
            res = a.col < b.col ? -1 : 1;
        } else {
            res = a.row < b.row ? -1 : 1;
        }
        return res;
    });
}